document.addEventListener('DOMContentLoaded', function () {
  const recentlyViewed = document.querySelector(
    '#shopify-block-AdEcvbEFGaEVJenJDc__recently_viewed_products_ts_recently_viewed_aEz43p'
  );

  const sectionToHide = document.querySelector(
    '#shopify-section-template--32830349345117__section_nXdJPD'
  );

  if (!recentlyViewed || !sectionToHide) return;

  function checkRecentlyViewed() {
    const isHidden =
      window.getComputedStyle(recentlyViewed).display === 'none';

    sectionToHide.style.display = isHidden ? 'none' : '';
  }

  checkRecentlyViewed();

  new MutationObserver(checkRecentlyViewed).observe(recentlyViewed, {
    attributes: true,
    attributeFilter: ['style', 'class']
  });
});